import React, { useState } from 'react';
import {Row, Col} from 'antd';
import {DownloadOutlined, UploadOutlined} from '@ant-design/icons';

// Store
import {useAppDispatch} from '../../store/store';
import {getRemissionTemplate} from '../../store/redux/actions/remissionActions';

// Components
import TitleComponent from '../subComponents/TitleComponent';
import ButtonComponent from '../subComponents/ButtonComponent';
import RemissionTable from './RemissionTable';
import UploadRemissionsModal from './UploadRemissionsModal';

// Constants and Functions
import {ROLES} from '../../utils/constants';
import {getLocalStorageItem} from '../../utils/functions';
import {routes} from "../../utils/routes";



const Remissions = () => {
  const dispatch = useAppDispatch();
  const [uploadModalVisible, setUploadModalVisible] = useState(false)
  const [downloadModalVisible, setDownloadModalVisible] = useState(false);
  const renderRole = getLocalStorageItem('renderRole');
  const allowedModules = ROLES[renderRole as keyof typeof ROLES].allowedModules as any[];
  const permissions = allowedModules.find(module => module.name === routes.remissions)!.permissions!;

  const handleModalVisible = (visible: boolean) => {
    setUploadModalVisible(visible);
  };

  const handleDownloadModalVisible = (visible: boolean) => {
    setDownloadModalVisible(visible);
  };

  return (
    <Row>
      <Col md={8} sm={8} xs={24}>
        <TitleComponent level={3} text={'Remisiones'} className={'font-semibold text-gray-900'} />
      </Col>

      {permissions.canUpload && permissions.canDownload &&
        <Col md={16} sm={16} xs={24} className={'text-right'}>
          <ButtonComponent text={'Cargar archivo'}
                           icon={<UploadOutlined/>}
                           className={'w-fit text-white bg-blue-dkt-400 hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
                             'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'}
                           onClick={() => handleModalVisible(true)}/>
          <ButtonComponent text={'Descargar plantilla'}
                           icon={<DownloadOutlined/>}
                           className={'w-fit text-white bg-blue-dkt-400 hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
                             'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'}
                           onClick={() => dispatch(getRemissionTemplate())}/>
          <ButtonComponent text={'Descargar archivo'}
                           icon={<DownloadOutlined/>}
                           className={'w-fit text-white bg-blue-dkt-400 hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
                             'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'}
                           onClick={() => handleDownloadModalVisible(true)}/>
        </Col>
      }

      <Col md={24} xs={24} className={'mt-5 p-6 border border-grey-dkt-300 rounded-lg overflow-hidden bg-white'}>
        <RemissionTable downloadModalVisible={downloadModalVisible} onToggleModal={handleDownloadModalVisible}/>
      </Col>

      {uploadModalVisible && <UploadRemissionsModal onToggleModal={setUploadModalVisible} />}
    </Row>
  );
}

export default Remissions;